import React, { ChangeEventHandler } from 'react';
import { ChecklistTasks } from '../../model/checklist/checklist';

/* Icons */

export interface ChecklistProps {
  task: ChecklistTasks;
  checked: boolean;
  updateChecklistEntry: (taskId: string, checked: boolean) => void;
  redirectionDisplay: boolean;
  redirectionFunction: ChangeEventHandler;
  disabled: boolean;
}

const CheckListTask: React.FC<ChecklistProps> = ({
  task,
  checked,
  updateChecklistEntry,
  redirectionDisplay,
  redirectionFunction,
  disabled,
}) => {
  const updateChecklist = (event) => {
    updateChecklistEntry(event.target.name, event.target.checked);
  };

  return (
    <li className={`flex items-center mb-4 w-auto`}>
      {task !== undefined ? (
        <>
          <input
            className="opacity-0 absolute w-full h-6 z-10 cursor-pointer"
            type="checkbox"
            name={task.checklist_tasks_key}
            checked={checked}
            disabled={disabled}
            onChange={
              redirectionDisplay ? redirectionFunction : updateChecklist
            }
          />
          <div className="relative w-6 h-6 mr-2 flex flex-shrink-0 justify-center items-center">
            <div
              className={`rounded-full bg-transparent border-gray-500 w-6 h-6  ${
                checked ? 'bg-primary border-0 opacity-30' : 'border-small'
              }`}
            ></div>
            <svg
              className={`${checked ? 'absolute block' : 'hidden'}`}
              width="14"
              height="14"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 1L3.9632 9.62271C3.88355 9.73715 3.77784 9.83102 3.65479 9.8966C3.53174 9.96218 3.39486 9.99758 3.25544 9.99988C3.11602 10.0022 2.97805 9.97133 2.8529 9.90985C2.72774 9.84838 2.61899 9.75805 2.5356 9.64631L1 7.59932"
                stroke="#47D7AC"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <label
            className={`text-white font-medium text-left ${
              checked ? 'text-primary line-through opacity-50' : ''
            }`}
          >
            {task?.checklist_tasks_title}
          </label>
        </>
      ) : (
        <></>
      )}
    </li>
  );
};

export default CheckListTask;
